import { render, staticRenderFns } from "./agregarComentario.vue?vue&type=template&id=5e61205a"
import script from "./agregarComentario.vue?vue&type=script&lang=js"
export * from "./agregarComentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports